module.exports = __webpack_public_path__ + "img/82a4e1c2-7ffd-4c58-86fa-4010a6723c8e.9d8a65e.svg";